import React from "react";
import { useMsal } from "@azure/msal-react";
import { Button, Typography } from "@mui/material";

export const SignOutButton = () => {
  const { instance, accounts } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
      idTokenHint: accounts[0]?.idToken,
    });
  };
  return (
    <>
      <Typography
        variant="h6"
        component="div"
        sx={{
          textAlign: "right",
          paddingRight: 3,
        }}
      >
        {accounts[0]?.name}
      </Typography>
      <Button variant="outlined" onClick={() => handleLogout()} color="inherit">
        Sign Out
      </Button>
    </>
  );
};
